import { render, staticRenderFns } from "./Archetype.vue?vue&type=template&id=3ca4bc5e"
import script from "./Archetype.vue?vue&type=script&lang=js"
export * from "./Archetype.vue?vue&type=script&lang=js"
import style0 from "./Archetype.vue?vue&type=style&index=0&id=3ca4bc5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports